import React from "react";
import { ArrowUp } from "lucide-react";
import { OdtWordmark } from "./OdtLogo";
import "./Header.css";

const Header = ({ scrolled }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <a href="#main" className="logo" aria-label="Oddtive — home">
          <OdtWordmark className="logo-mark" />
        </a>
        <nav className="nav" aria-label="Primary">
          <a href="#story" className="nav-link">About</a>
          <a href="#pricing" className="nav-link">Packages</a>
          <a href="#contact" className="nav-link">Contact</a>
        </nav>
        {scrolled && (
          <button onClick={scrollToTop} className="back-to-top" aria-label="Back to top">
            <ArrowUp size={20} />
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;